export default "__VITE_ASSET__bb6b28b2__"